/* eslint-disable max-len */
export const convertToPatientTimeZoneDateFormat = (timestamp, format, timezone) => {
    if (timestamp === 0 || timezone === '-') {
        return '-';
    }

    const date = new Date(timestamp * 1000); // Convert to milliseconds

    // Use Intl.DateTimeFormat to get date/time parts based on the timezone
    const getTimeInTimeZone = (date, timeZone) => {
        const options = {
            timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        };
        const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date);

        const getPart = (type) => parts.find((p) => p.type === type)?.value;

        return {
            day: getPart('day'),
            month: getPart('month'),
            year: getPart('year'),
            hour: getPart('hour'),
            minute: getPart('minute'),
            second: getPart('second'),
        };
    };

    let formattedDate = '';
    const { day, month, year, hour, minute, second } = getTimeInTimeZone(date, timezone);

    // Ensure values are correctly formatted without leading zeros
    const removeLeadingZeros = (value) => parseInt(value, 10).toString();

    switch (format) {
    case 'DD/MM/YYYY, 24hrs, No leading zeros':
        formattedDate = `${removeLeadingZeros(day)}/${removeLeadingZeros(month)}/${year} ${removeLeadingZeros(hour)}:${removeLeadingZeros(minute)}:${removeLeadingZeros(second)}`;
        break;

    case 'MM/DD/YYYY, 24hrs, No leading zeros':
        formattedDate = `${removeLeadingZeros(month)}/${removeLeadingZeros(day)}/${year} ${removeLeadingZeros(hour)}:${removeLeadingZeros(minute)}:${removeLeadingZeros(second)}`;
        break;

    case 'DD/MM/YYYY, 24hrs, Leading zeros':
        formattedDate = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year} ${hour.padStart(2, '0')}:${minute}:${second}`;
        break;

    case 'MM/DD/YYYY, 24hrs, Leading zeros':
        formattedDate = `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year} ${hour.padStart(2, '0')}:${minute}:${second}`;
        break;

    case 'DD/MM/YYYY, AM/PM, No leading zeros': {
        const hours12 = hour % 12 || 12;
        const amPm = hour >= 12 ? 'PM' : 'AM';
        formattedDate = `${removeLeadingZeros(day)}/${removeLeadingZeros(month)}/${year} ${hours12}:${removeLeadingZeros(minute)}:${removeLeadingZeros(second)} ${amPm}`;
        break;
    }

    case 'MM/DD/YYYY, AM/PM, No leading zeros': {
        const hours12 = hour % 12 || 12;
        const amPm = hour >= 12 ? 'PM' : 'AM';
        formattedDate = `${removeLeadingZeros(month)}/${removeLeadingZeros(day)}/${year} ${hours12}:${removeLeadingZeros(minute)}:${removeLeadingZeros(second)} ${amPm}`;
        break;
    }

    case 'DD/MM/YYYY, AM/PM, Leading zeros': {
        const hours12 = hour % 12 || 12;
        const amPm = hour >= 12 ? 'PM' : 'AM';
        formattedDate = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year} ${hours12.toString().padStart(2, '0')}:${minute}:${second} ${amPm}`;
        break;
    }

    case 'MM/DD/YYYY, AM/PM, Leading zeros': {
        const hours12 = hour % 12 || 12;
        const amPm = hour >= 12 ? 'PM' : 'AM';
        formattedDate = `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year} ${hours12.toString().padStart(2, '0')}:${minute}:${second} ${amPm}`;
        break;
    }

    default:
        formattedDate = `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    }

    return formattedDate;
};